import React from "react";

const MailLink = ({data}) => {
  return <a href={`mailto:${data}`}>{data}</a>;
}

export default MailLink;